/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Answer/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaProfileValueWithLabelText from 'DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/index'



/** @type {import('Simple/types.js').View} */
export default function Answer({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/Answers/Answer"
  
}) {
let answerQuestionValueData = fromData.useDataValue({ viewPath,
context: 'answer',
path: 'question',
})
let answerAnswerValueData = fromData.useDataValue({ viewPath,
context: 'answer',
path: 'answer',
})
  return (<React.Fragment
>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 isHorizontal={true}
 data="answer.question"
 label={answerQuestionValueData}
 data="answer.answer"
 value={answerAnswerValueData}
/>
{children}
</React.Fragment>)
}